import axios from 'axios'
const url = 'https://www.lefisc.com.br/api/covid19/'
const chave = '7c555a0cc655264a9455770359ffb7d9' 
export default {
    getInfo() {
        return axios
            .get(`${url}info/${chave}`)
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getEstados() {
        return axios
            .get(`${url}estados/${chave}`)
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getCategorias() {
        return axios
            .get(`${url}categorias/${chave}`)
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getDescEstado(categoria,descricao,estado) {
        return axios
            .post(`${url}infoDescricaoEstado/${chave}`,{
                "idCategoria":categoria,
                "descricao":descricao,
            	"idEstado":estado,
            })
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    getLinks() {
        return axios
            .get(`${url}links/${chave}`)
            .then(res => res.data)
            .catch(err => console.log(err));
    },
}

